export default __webpack_public_path__ + "static/media/payment2.64496704.png";